import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { statusMessages } from './messages'
import { GTBookingV2Status } from 'gql/types.generated'
import { ReactElement } from 'react'

export const getStatusColor = (status: TSFixMe): TSFixMe => {
  switch (status) {
    case GTBookingV2Status.Confirmed:
    case GTBookingV2Status.PartiallyConfirmed:
      return '#66bb6a'
    case GTBookingV2Status.Reserved:
      return '#2e7d32'
    case GTBookingV2Status.Incomplete:
      return '#5d5c70'
    case GTBookingV2Status.Failed:
      return '#f57c00'
    case GTBookingV2Status.Paid:
      return '#d84315'
    case GTBookingV2Status.Cancelled:
      return '#9e9e9e'
  }
}

const Status = styled.div<{ status: GTBookingV2Status }>`
  color: ${({ status }): string => getStatusColor(status)};
`

interface IBookingStatusProps {
  status: GTBookingV2Status
}

export const BookingStatus = ({ status }: IBookingStatusProps): ReactElement => {
  const intl = useIntl()

  if (statusMessages[status]) {
    return <Status status={status}>{intl.formatMessage(statusMessages[status])}</Status>
  }

  return <div>{status}</div>
}
